<div class="item-data">
    @if (paymentCart.hawb) {
        <div class="payment-type-section d-flex">
            @if (isDuplicated) {
                <mat-icon
                    color="accent"
                    class="material-symbols-outlined md-icon-18 overflow-visible"
                    [attr.aria-label]="'Duplicated HAWB warning'"
                    role="img"
                >
                    warning_amber
                </mat-icon>
            }
            <div class="mat-caption item-data__title">
                {{ labelHAWB }}:
                <span class="text-break item-data__value">{{ paymentCart.hawb }}</span>
            </div>
        </div>
    }
    <div class="payment-type-section d-flex">
        @if (isDuplicated && !paymentCart.hawb) {
            <mat-icon color="accent" class="material-symbols-outlined md-icon-18 overflow-visible">
                warning_amber
            </mat-icon>
        }
        <div class="mat-caption item-data__title">
            Payment type:
            <span class="text-break item-data__value">{{ paymentCart.externalData?.paymentType }}</span>
        </div>
    </div>
    @if (paymentCart.externalData?.source === 'DSV_AIR') {
        <div class="d-flex align-items-center">
            <div class="mat-caption item-data__title">
                Shipment Number:
                <span class="text-break item-data__value">{{ paymentCart.hawb }}</span>
            </div>
        </div>
    }
</div>
